<ng-container *ngTemplateOutlet="contentRef"></ng-container>
